import React from 'react';
import { styled, LazyImage } from '@teko/ui';
import { SpaceProps, space } from 'styled-system';
import { NewsFeedEntity } from 'types';
import { getDateStringWithFormat } from '@teko/ui-cart';
import Link from 'next/link';

export interface NewsCardProps extends SpaceProps {
  feed: NewsFeedEntity;
}

export const NewsCard = ({ feed, ...props }: NewsCardProps) => {
  return (
    <Link
      href={{
        pathname: '/tin-tuc/[slug]',
        query: {
          slug: feed.urlKey,
        },
      }}
      as={`/tin-tuc/${feed?.urlKey || ''}`}
      legacyBehavior
    >
      <FeedCard {...props}>
        <LazyImage src={feed.imageUrl || ''} aspectRatio={1.5} cover />
        <FeedContent>
          <FeedTitle>{feed.name}</FeedTitle>
          <FeedDate>
            {feed.updateAt && getDateStringWithFormat(feed?.updateAt)}
          </FeedDate>
          <FeedDescription
            dangerouslySetInnerHTML={{
              __html: stripNewsContent(feed?.content || ''),
            }}
          ></FeedDescription>
        </FeedContent>
      </FeedCard>
    </Link>
  );
};

const FeedCard = styled.div(
  space,
  () => `
  border-radius: 8px;
  box-shadow: 0 2px 8px rgb(0 0 0 / 20%);
  overflow: hidden;
  cursor: pointer;
  height: 100%;
`,
);

const FeedTitle = styled.div`
  line-height: 20px;
  margin: 8px 0;
  font-size: 1.25rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
`;

const FeedDate = styled.div`
  color: #666;
  font-size: 0.875rem;
`;

const FeedDescription = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 8px 0;
`;

const FeedContent = styled.div`
  padding: 0.5rem 1rem;
  background-color: #ffffff;
`;

export const stripNewsContent = (string: string): string => {
  return string
    .replace(/<\/?[^>]+>/gi, ' ')
    .replace(/<img[^>"']*((("[^"]*")|('[^']*'))[^"'>]*)*>/g, '')
    .substring(0, 200);
};
